import Config from '@/config'

// Review-only: lets a sandbox link open with the report locked; inert outside local/develop builds.
const STORAGE_KEY = 'reportLockPreview'
const PARAM_NAME = 'reportLockPreview'
const PREVIEW_ALLOWED_ENVS = ['local', 'develop']

export const isReportLockPreviewActive = ({
  env = Config.env,
  search = window.location.search,
  storage,
} = {}) => {
  if (!PREVIEW_ALLOWED_ENVS.includes(env)) return false
  try {
    const store = storage || window.sessionStorage
    const requested = new URLSearchParams(search).get(PARAM_NAME)
    if (requested === '1') store.setItem(STORAGE_KEY, '1')
    if (requested === '0') store.removeItem(STORAGE_KEY)
    return store.getItem(STORAGE_KEY) === '1'
  } catch (error) {
    return false
  }
}
